import { useEffect, useState } from "react";

import colors from "@moodys/mdc-frontend.theming.colors";
import { Helmet, HelmetProvider } from "react-helmet-async";

export const Favicon = () => {
  const [preferredColorScheme, setPreferredColorScheme] = useState(
    window.matchMedia("(prefers-color-scheme:dark)").matches ? "dark" : "light"
  );

  useEffect(() => {
    const mediaQueryList = window.matchMedia("(prefers-color-scheme:dark)");

    const handleMediaQueryListChange = (ev: MediaQueryListEvent) => {
      setPreferredColorScheme(
        (ev.currentTarget as MediaQueryList).matches ? "dark" : "light"
      );
    };
    mediaQueryList.addEventListener("change", handleMediaQueryListChange);

    return () => {
      mediaQueryList.removeEventListener("change", handleMediaQueryListChange);
    };
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <link
          rel="icon"
          type="image/x-icon"
          href={`/asset/images/favicon/${preferredColorScheme}/favicon.ico`}
        />
        <link
          rel="icon"
          href={`/asset/images/favicon/${preferredColorScheme}/favicon.svg`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`/asset/images/favicon/${preferredColorScheme}/favicon-32x32.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`/asset/images/favicon/${preferredColorScheme}/favicon-16x16.png`}
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/asset/images/favicon/apple-touch-icon.png"
        />
        <link rel="manifest" href="/asset/images/favicon/site.webmanifest" />
        <link
          rel="mask-icon"
          href="/asset/images/favicon/safari-pinned-tab.svg"
          color={colors.globalBlue700}
        />
        <meta name="msapplication-TileColor" content={colors.globalBlue700} />
        <meta name="theme-color" content={colors.globalBlue700} />
      </Helmet>
    </HelmetProvider>
  );
};
